import { navigateTo } from "../../widgets/navigationService/navigationServiceFunctions";

export function escapeBack(location: any) {
    const pathname = location?.pathname;
    if (pathname !== "/app/roads/list") navigateTo(-1);
}